export default __webpack_public_path__ + "static/media/xm-black.58563f4a.svg";